import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useResponsive } from '../hooks/useResponsive';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import blog1 from '../blog1.png';
import coeurs from '../coeurs.png';
import {
    FaPaperPlane, FaArrowRight, FaEnvelope, FaWhatsapp, FaRegClock,
    FaRegQuestionCircle, FaRegLightbulb, FaHandshake, FaRegCalendarAlt,
    FaRegUser, FaSearch, FaRegTrashAlt, FaRegCreditCard, FaFlag,
    FaFacebookF, FaTelegramPlane, FaRegBell
} from 'react-icons/fa';
import { GoShieldCheck } from 'react-icons/go';
import { MdOutlineLock } from 'react-icons/md';

import { useAuth } from '../context/AuthContext';
import NavbarAuth from '../components/NavbarAuth';
const Contact = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const { isSmall, isMobile } = useResponsive();
    // Comportement original : isTablet = tout ce qui est <= 1024 (mobile inclus)
    const isTablet = typeof window !== 'undefined' && window.innerWidth <= 1024;

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [openFaq, setOpenFaq] = useState(null);
    const [status, setStatus] = useState('');
    const [sending, setSending] = useState(false);
    const [horaires, setHoraires] = useState(null);

    // Horaires d'affichage (route publique, pas besoin d'être connecté)
    useEffect(() => {
        const base = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
        fetch(`${base}/moderation/public`)
            .then(r => r.ok ? r.json() : null)
            .then(d => { if (d) setHoraires(d); })
            .catch(() => { });
    }, []);

    // Construit les 2 lignes du bloc Horaires à partir des réglages admin
    const JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    const horairesLigne1 = () => {
        if (!horaires) return '7j/7 : 10h - 22h';
        const jf = horaires.jour_ferme;
        const prefixe = (jf === null || jf === undefined) ? '7j/7' : '6j/7';
        if (horaires.actif === false) return `${prefixe} : 24h/24`;
        return `${prefixe} : ${horaires.heure_debut}h - ${horaires.heure_fin}h`;
    };
    const horairesLigne2 = () => {
        if (!horaires) return 'Toute la semaine';
        const jf = horaires.jour_ferme;
        return (jf === null || jf === undefined) ? 'Toute la semaine' : `Fermé le ${JOURS[jf]}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSending(true);
        setStatus('');
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}/contact`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, email, subject, message }),
            });
            console.log('Réponse reçue, status:', res.status);
            if (!res.ok) throw new Error('Erreur serveur');
            setStatus('success');
            setName(''); setEmail(''); setSubject(''); setMessage('');
        } catch (err) {
            console.log('Erreur attrapée:', err);
            setStatus('error');
        } finally {
            setSending(false);
        }
    };

    // Consigne logique : une aide contextuelle qui change selon le sujet
    // sélectionné dans le formulaire, pour guider ce que la personne doit écrire.
    const subjectHints = {
        aide: "Précisez la page ou fonctionnalité concernée, le problème rencontré, et si possible une capture d'écran à joindre plus tard.",
        suggestion: "Décrivez votre idée et en quoi elle améliorerait votre expérience sur la plateforme.",
        partenariat: "Indiquez votre structure, le type de collaboration envisagée et vos coordonnées professionnelles.",
        autre: "Décrivez votre demande le plus précisément possible pour que nous puissions vous répondre rapidement.",
    };

    const subjectPlaceholders = {
        aide: "Ex : Depuis hier, je n'arrive pas à valider mon profil, un message d'erreur s'affiche...",
        suggestion: "Ex : Il serait utile d'ajouter un filtre par ville dans la recherche de profils...",
        partenariat: "Ex : Nous représentons une association et souhaiterions explorer un partenariat...",
        autre: "Décrivez votre demande",
    };

    // Liens vers les réseaux sociaux (à remplacer par les vraies URLs de la page/du compte)
    const socialLinks = [
        { icon: <FaFacebookF size={18} />, label: 'Facebook', href: 'https://facebook.com/zawajtawadud' },
        { icon: <FaWhatsapp size={18} />, label: 'WhatsApp', href: 'https://wa.me/33601020304' },
        { icon: <FaTelegramPlane size={18} />, label: 'Telegram', href: 'https://t.me/zawajtawadud' },
    ];

    const infoCards = [
        { icon: <FaEnvelope size={20} color="#c0306a" />, title: 'Email', line1: 'contact@zawaj-tawadud.com', line2: 'Nous répondons sous 24h' },
        { icon: <FaTelegramPlane size={20} color="#c0306a" />, title: 'Telegram', line1: '@zawajtawadud', line2: 'Réponse rapide garantie' },
        { icon: <FaRegClock size={20} color="#c0306a" />, title: 'Horaires', line1: horairesLigne1(), line2: horairesLigne2() },
        { icon: <GoShieldCheck size={20} color="#c0306a" />, title: 'Confidentialité', line1: 'Vos données sont protégées', line2: 'et restent confidentielles' },
    ];

    const faqList = [
        { icon: <FaRegQuestionCircle size={14} color="#c0306a" />, q: 'Comment fonctionne la plateforme ?', a: "Le parcours se déroule en 4 étapes : inscription, validation du profil, activation de l'adhésion (paiement), puis accès aux profils et demandes de mise en relation." },
        { icon: <FaHandshake size={14} color="#c0306a" />, q: 'Comment se passe une mise en relation ?', a: "Lorsqu'un profil vous intéresse, vous faites une demande qui est transmise à la personne concernée. Elle dispose de 48 heures pour répondre. En cas d'accord des deux côtés, la mise en relation est effectuée manuellement par nos soins." },
        { icon: <MdOutlineLock size={14} color="#c0306a" />, q: 'Puis-je contacter directement une personne ?', a: "Non. Aucun échange direct n'est possible sur la plateforme. Les mises en relation sont gérées en interne." },
        { icon: <FaPaperPlane size={14} color="#c0306a" />, q: 'Combien de demandes puis-je faire ?', a: "Vous pouvez faire une demande à la fois. Une nouvelle demande pourra être effectuée après réponse ou clôture de la précédente." },
        { icon: <FaRegClock size={14} color="#c0306a" />, q: 'Que se passe-t-il si je ne reçois pas de réponse ?', a: "Si aucune réponse n'est donnée dans un délai de 48 heures, la demande est clôturée. Vous pourrez alors faire une nouvelle demande." },
        { icon: <FaSearch size={14} color="#c0306a" />, q: 'Pourquoi certains profils ne sont plus disponibles ?', a: "Un profil devient temporairement indisponible lorsqu'une mise en relation est en cours. Si la démarche n'aboutit pas, le profil peut redevenir disponible." },
        { icon: <FaRegUser size={14} color="#c0306a" />, q: 'Quelles informations sont visibles sur mon profil ?', a: "Seules les informations nécessaires sont affichées. Les membres vous identifient par votre kounya : vos nom et prénom réels ne sont ni demandés ni affichés." },
        { icon: <FaRegCreditCard size={14} color="#c0306a" />, q: 'Comment se passe le paiement ?', a: "L'accès à la plateforme est payant selon la formule choisie. Les formules sont sans engagement. Pour continuer à accéder aux profils, il est nécessaire de renouveler son abonnement à la fin de la période choisie. En cas de non-renouvellement, l'accès aux fonctionnalités sera suspendu." },
        { icon: <FaRegTrashAlt size={14} color="#c0306a" />, q: 'Puis-je arrêter à tout moment ?', a: "Oui. Les formules sont sans engagement." },
        { icon: <FaRegLightbulb size={14} color="#c0306a" />, q: 'Pourquoi ce fonctionnement sans messagerie ?', a: "Le but est de préserver un cadre sérieux et respectueux. Les échanges ne se font pas librement mais passent par un processus encadré." },
        { icon: <FaRegBell size={14} color="#c0306a" />, q: 'Comment être prévenu des demandes et des messages ?', a: "Une cloche est affichée dans la barre du site. Elle vous signale cinq choses : une nouvelle demande de mise en relation, un intérêt reçu, un message validé par la modération, la fin d'un échange, et le résultat de l'examen de votre profil. Nous vous conseillons vivement d'activer les notifications sur votre appareil : vous serez alors prévenu même lorsque le site est fermé, et vous ne laisserez pas une demande expirer faute de l'avoir vue à temps. Pour cela, ouvrez la cloche et cliquez sur « Activer », ou utilisez le rappel affiché en haut de la page « Les profils »." },
        { icon: <FaRegBell size={14} color="#c0306a" />, q: 'Je suis sur iPhone et je ne vois pas le bouton « Activer »', a: "C'est normal : sur iPhone, Apple n'autorise les notifications que si le site a été ajouté à l'écran d'accueil. Ouvrez le site dans Safari, appuyez sur le bouton Partager en bas de l'écran, choisissez « Sur l'écran d'accueil », puis ouvrez le site depuis cette nouvelle icône. Le bouton « Activer » apparaîtra alors dans la cloche. Sur Android, aucune manipulation n'est nécessaire." },
    ];

    return (
        <div style={{ fontFamily: 'Arial, sans-serif', overflowX: 'hidden', backgroundColor: '#faf6f8' }}>

            {/* ═══════════ NAVBAR ═══════════ */}
            {user ? <NavbarAuth /> : <Navbar />}

            {/* ═══════════ HERO sombre + image roses droite ═══════════ */}
            <section style={{
                position: 'relative',
                backgroundColor: '#1a0010',
                overflow: 'hidden',
                minHeight: isMobile ? 'auto' : '400px',
            }}>
                {!isMobile && (
                    <div style={{
                        position: 'absolute', top: 0, right: 0,
                        width: '90%', height: '100%',
                        backgroundImage: `url(${blog1})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        WebkitMaskImage: 'linear-gradient(to left, black 60%, transparent 100%)',
                        maskImage: 'linear-gradient(to left, black 60%, transparent 100%)',
                    }} />
                )}
                <div style={{
                    position: 'relative', zIndex: 2,
                    maxWidth: '1200px', margin: '0 auto',
                    padding: isSmall ? '40px 20px' : isMobile ? '48px 24px' : '64px 48px',
                }}>
                    <div style={{ maxWidth: '520px' }}>
                        <p style={{ color: '#E88BB4', fontSize: '11px', fontWeight: '700', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '12px', marginTop: 0 }}>CONTACTEZ-NOUS</p>
                        <h1 style={{
                            color: 'white', fontWeight: '700',
                            fontSize: isSmall ? '30px' : isMobile ? '36px' : '46px',
                            lineHeight: '1.15', marginBottom: '18px', marginTop: 0,
                            fontFamily: 'Cormorant Garamond, serif',
                        }}>
                            Nous sommes là<br />
                            pour vous <span style={{ color: '#E88BB4', whiteSpace: 'nowrap' }}>
                                écouter
                                <img src={coeurs} alt="" style={{ height: isMobile ? '32px' : '46px', verticalAlign: 'middle', marginLeft: '-6px' }} />
                            </span>
                        </h1>
                        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px', lineHeight: '1.8', margin: 0 }}>
                            Une question, un besoin d'accompagnement ou une suggestion ?
                            L'équipe Zawaj & Tawadud est à votre disposition pour vous répondre
                            dans le respect, la bienveillance et la confidentialité.
                        </p>
                    </div>
                </div>
            </section>

            {/* ═══════════ 4 CARTES INFO (chevauchant le hero) ═══════════ */}
            <section style={{ backgroundColor: '#faf6f8', padding: isMobile ? '0 16px' : '0 24px' }}>
                <div style={{
                    maxWidth: '1120px', margin: '0 auto',
                    marginTop: isMobile ? '-20px' : '-50px',
                    position: 'relative', zIndex: 5,
                    backgroundColor: '#ffffff',
                    borderRadius: '16px',
                    boxShadow: '0 8px 32px rgba(120,24,64,0.10)',
                    padding: isMobile ? '24px 16px' : '32px 24px',
                    display: 'grid',
                    gridTemplateColumns: isSmall ? '1fr 1fr' : isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
                    gap: isSmall ? '20px' : '0px',
                }}>
                    {infoCards.map((c, i) => (
                        <div key={i} style={{
                            textAlign: 'center', padding: isSmall ? '8px' : '8px 20px',
                            borderRight: (!isMobile && i < 3) ? '1px solid #f0dde6' : 'none',
                        }}>
                            <div style={{ width: '48px', height: '48px', borderRadius: '50%', backgroundColor: 'rgba(192,48,106,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                                {c.icon}
                            </div>
                            <h4 style={{ color: '#1a0010', fontSize: '15px', fontWeight: '700', margin: '0 0 8px 0' }}>{c.title}</h4>
                            <p style={{ color: '#555', fontSize: '12px', margin: '0 0 4px 0' }}>{c.line1}</p>
                            <p style={{ color: '#999', fontSize: '11px', margin: 0 }}>{c.line2}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ═══════════ FORMULAIRE + AUTRES MOYENS ═══════════ */}
            <section style={{ backgroundColor: '#faf6f8', padding: isMobile ? '32px 16px' : '48px 24px' }}>
                <div style={{
                    maxWidth: '1120px', margin: '0 auto',
                    display: 'flex', flexDirection: isMobile ? 'column' : 'row',
                    gap: '24px', alignItems: 'stretch',
                }}>
                    {/* Formulaire */}
                    <div style={{
                        flex: isMobile ? 'none' : '1.4',
                        backgroundColor: 'white', borderRadius: '16px',
                        border: '1px solid #eedde6',
                        boxShadow: '0 4px 20px rgba(192,48,106,0.07)',
                        padding: isSmall ? '24px 18px' : '32px 36px',
                    }}>
                        <h2 style={{ color: '#1a0010', fontSize: isMobile ? '20px' : '24px', fontWeight: '700', textAlign: 'center', marginTop: 0, marginBottom: '6px', fontFamily: 'Cormorant Garamond, serif' }}>
                            Envoyez-nous un message
                        </h2>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', marginBottom: '24px' }}>
                            <div style={{ width: '24px', height: '2px', backgroundColor: '#c0306a' }} />
                            <div style={{ width: '6px', height: '6px', transform: 'rotate(45deg)', backgroundColor: '#c0306a' }} />
                            <div style={{ width: '24px', height: '2px', backgroundColor: '#c0306a' }} />
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div style={{ display: 'flex', gap: '14px', flexDirection: isSmall ? 'column' : 'row', marginBottom: '16px' }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{ display: 'block', color: '#1a0010', fontSize: '13px', fontWeight: '600', marginBottom: '7px' }}>Votre nom</label>
                                    <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Entrez votre nom" required
                                        style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #eedde6', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box', color: '#333', backgroundColor: '#fff' }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={{ display: 'block', color: '#1a0010', fontSize: '13px', fontWeight: '600', marginBottom: '7px' }}>Votre email</label>
                                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Entrez votre email" required
                                        style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #eedde6', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box', color: '#333', backgroundColor: '#fff' }} />
                                </div>
                            </div>

                            <div style={{ marginBottom: subject ? '10px' : '16px' }}>
                                <label style={{ display: 'block', color: '#1a0010', fontSize: '13px', fontWeight: '600', marginBottom: '7px' }}>Sujet</label>
                                <select value={subject} onChange={e => setSubject(e.target.value)}
                                    style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #eedde6', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box', color: subject ? '#333' : '#aaa', backgroundColor: '#fff', appearance: 'none', cursor: 'pointer' }}>
                                    <option value="">Sélectionnez un sujet</option>
                                    <option value="aide">Besoin d'aide</option>
                                    <option value="suggestion">Suggestion</option>
                                    <option value="partenariat">Partenariat</option>
                                    <option value="autre">Autre</option>
                                </select>

                                {/* Consigne logique : indication contextuelle liée au sujet choisi,
                                    pour guider ce que la personne doit préciser dans son message. */}
                                {subject && (
                                    <p style={{ display: 'flex', alignItems: 'flex-start', gap: '6px', color: '#c0306a', fontSize: '11px', lineHeight: '1.6', margin: '8px 0 0 0' }}>
                                        <FaRegLightbulb size={12} style={{ flexShrink: 0, marginTop: '2px' }} />
                                        <span>{subjectHints[subject]}</span>
                                    </p>
                                )}
                            </div>

                            <div style={{ marginBottom: '14px' }}>
                                <label style={{ display: 'block', color: '#1a0010', fontSize: '13px', fontWeight: '600', marginBottom: '7px' }}>Votre message</label>
                                <textarea value={message} onChange={e => setMessage(e.target.value)} placeholder={subject ? subjectPlaceholders[subject] : 'Décrivez votre demande'} rows={5} required
                                    style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #eedde6', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box', color: '#333', backgroundColor: '#fff', resize: 'vertical', fontFamily: 'Arial, sans-serif' }} />
                            </div>

                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '18px' }}>
                                <MdOutlineLock size={14} color="#aaa" style={{ flexShrink: 0, marginTop: '2px' }} />
                                <p style={{ color: '#999', fontSize: '11px', lineHeight: '1.6', margin: 0 }}>
                                    Vos informations sont strictement confidentielles et utilisées uniquement pour répondre à votre demande.
                                </p>
                            </div>

                            {status === 'success' && (
                                <div style={{ backgroundColor: '#f0fff0', color: '#1a6a1a', padding: '10px 14px', borderRadius: '8px', marginBottom: '14px', fontSize: '13px' }}>
                                    Votre message a bien été envoyé. Nous vous répondrons sous 24h.
                                </div>
                            )}
                            {status === 'error' && (
                                <div style={{ backgroundColor: '#ffe0e0', color: '#c00', padding: '10px 14px', borderRadius: '8px', marginBottom: '14px', fontSize: '13px' }}>
                                    Une erreur est survenue. Veuillez réessayer.
                                </div>
                            )}

                            <button type="submit" disabled={sending} style={{ width: '100%', padding: '13px', background: 'linear-gradient(135deg, #3d0820, #781840)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px', cursor: sending ? 'not-allowed' : 'pointer', fontWeight: '600', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxShadow: '0 4px 16px rgba(120,24,64,0.3)', fontFamily: 'Arial, sans-serif', opacity: sending ? 0.7 : 1 }}>
                                <span>{sending ? 'Envoi en cours...' : 'Envoyer le message'}</span>
                                {!sending && <FaPaperPlane size={13} />}
                            </button>
                        </form>
                    </div>

                    {/* Autres moyens (carte sombre) */}
                    <div style={{
                        flex: 1,
                        backgroundColor: '#4a0028',
                        borderRadius: '16px',
                        boxShadow: '0 4px 20px rgba(120,24,64,0.25)',
                        padding: isSmall ? '24px 18px' : '32px 30px',
                    }}>
                        <h2 style={{ color: 'white', fontSize: isMobile ? '20px' : '24px', fontWeight: '700', textAlign: 'center', marginTop: 0, marginBottom: '6px', fontFamily: 'Cormorant Garamond, serif' }}>
                            À propos de ce formulaire
                        </h2>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', marginBottom: '24px' }}>
                            <div style={{ width: '24px', height: '2px', backgroundColor: '#E88BB4' }} />
                            <div style={{ width: '6px', height: '6px', transform: 'rotate(45deg)', backgroundColor: '#E88BB4' }} />
                            <div style={{ width: '24px', height: '2px', backgroundColor: '#E88BB4' }} />
                        </div>

                        {/* Explication de ce que fait le formulaire */}
                        <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '13px', lineHeight: '1.8', margin: '0 0 28px 0' }}>
                            Ce formulaire nous transmet directement votre message, quel que soit le sujet :
                            une question sur votre compte, un souci technique, une suggestion pour la
                            plateforme ou une demande de partenariat. Chaque message est lu par notre équipe
                            et vous recevez une réponse par email sous 24h.
                        </p>

                        <h4 style={{ color: 'white', fontSize: '13px', fontWeight: '700', margin: '0 0 14px 0', textAlign: 'center', letterSpacing: '1px', textTransform: 'uppercase' }}>
                            Suivez-nous
                        </h4>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '14px' }}>
                            {socialLinks.map((s, i) => (
                                <a
                                    key={i}
                                    href={s.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={s.label}
                                    style={{
                                        width: '46px', height: '46px', borderRadius: '50%',
                                        backgroundColor: 'rgba(232,139,180,0.12)',
                                        color: '#E88BB4',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        textDecoration: 'none',
                                        border: '1px solid rgba(232,139,180,0.25)',
                                        transition: 'background-color 0.2s',
                                    }}
                                >
                                    {s.icon}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* ═══════════ FAQ ═══════════ */}
            <section id="faq" style={{ backgroundColor: '#faf6f8', padding: isMobile ? '0 16px 32px' : '0 24px 48px', scrollMarginTop: '90px' }}>
                <div style={{
                    maxWidth: '1120px', margin: '0 auto',
                    backgroundColor: 'white', borderRadius: '16px',
                    border: '1px solid #eedde6',
                    boxShadow: '0 4px 20px rgba(192,48,106,0.07)',
                    padding: isSmall ? '24px 18px' : '32px 36px',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
                        <h2 style={{ color: '#1a0010', fontSize: isMobile ? '20px' : '24px', fontWeight: '700', margin: 0, fontFamily: 'Cormorant Garamond, serif' }}>
                            Questions fréquentes
                        </h2>
                        <p style={{ color: '#999', fontSize: '12px', lineHeight: '1.6', margin: 0, maxWidth: '280px' }}>
                            Consultez notre FAQ pour trouver rapidement des réponses aux questions les plus courantes.
                        </p>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '12px', alignItems: 'start' }}>
                        {faqList.map((item, i) => {
                            const isOpen = openFaq === i;
                            return (
                                <div key={i} style={{ backgroundColor: '#faf6f8', border: '1px solid #eedde6', borderRadius: '10px', overflow: 'hidden' }}>
                                    <div onClick={() => setOpenFaq(isOpen ? null : i)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', cursor: 'pointer' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: '#fde8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                {item.icon}
                                            </div>
                                            <span style={{ color: '#1a0010', fontSize: '13px', fontWeight: '500' }}>{item.q}</span>
                                        </div>
                                        <span style={{ color: '#c0306a', fontSize: '11px', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s', flexShrink: 0, marginLeft: '8px' }}>▼</span>
                                    </div>
                                    {isOpen && (
                                        <div style={{ padding: '0 14px 14px 58px' }}>
                                            <p style={{ color: '#666', fontSize: '12px', lineHeight: '1.7', margin: 0 }}>{item.a}</p>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* ═══════════ CTA accompagnement personnalisé ═══════════ */}
            <section style={{ backgroundColor: '#faf6f8', padding: isMobile ? '0 16px 32px' : '0 24px 48px' }}>
                <div style={{
                    position: 'relative',
                    maxWidth: '1120px', margin: '0 auto',
                    borderRadius: '16px', overflow: 'hidden',
                    backgroundImage: `url(${blog1})`,
                    backgroundSize: 'cover', backgroundPosition: 'center',
                }}>
                    <div style={{ position: 'absolute', inset: 0 }} />
                    <div style={{
                        position: 'relative', zIndex: 2,
                        display: 'flex', flexDirection: isMobile ? 'column' : 'row',
                        alignItems: 'center', justifyContent: 'space-between',
                        padding: isMobile ? '28px 20px' : '36px 44px',
                        gap: '20px',
                    }}>
                        <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
                            <h2 style={{ color: 'white', fontSize: isSmall ? '20px' : '24px', fontWeight: '700', marginBottom: '8px', marginTop: 0, fontFamily: 'Cormorant Garamond, serif' }}>
                                Besoin d'un accompagnement personnalisé ?
                            </h2>
                            <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '13px', lineHeight: '1.7', margin: 0 }}>
                                Nos conseillers sont là pour vous guider<br />dans votre démarche en toute bienveillance.
                            </p>
                        </div>
                        <div style={{ textAlign: 'center', flexShrink: 0 }}>
                            <button style={{ backgroundColor: '#4a0028', color: 'white', border: 'none', borderRadius: '8px', padding: '13px 26px', fontSize: '14px', cursor: 'pointer', fontWeight: '700', display: 'inline-flex', alignItems: 'center', gap: '8px', fontFamily: 'Arial, sans-serif' }}>
                                <FaRegCalendarAlt size={14} /> Prendre rendez-vous
                            </button>
                            <p style={{ color: 'white', fontSize: '11px', margin: '8px 0 0 0' }}>Service disponible sur demande</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* ═══════════ FOOTER ═══════════ */}
            <Footer />

        </div>
    );
};

export default Contact;